import { transformMaskedQueryToCql } from '@app/components';

import {
  ALL_RECORDS_CQL,
  SEARCH_OPTION,
  searchOptionMap,
} from '../../constants';

export const forbiddenCharacters = ['=', ';', ',', '%', '@', '#', '!'];

export const sanitizeQuery = (query: string) => {
  const escapedQuery = query?.replace(/[\\"]/g, '\\$&');
  const forbiddenCharactersRegex = new RegExp(
    `[${forbiddenCharacters.join('\\')}]`,
    'g'
  );

  return escapedQuery.replace(forbiddenCharactersRegex, '').trim();
};

export const getQueryCQL = (query: string, option: string): string => {
  const sanitizedQuery = sanitizeQuery(query);

  if (
    searchOptionMap[option] === searchOptionMap[SEARCH_OPTION.keyword] &&
    (!query || query === '*')
  ) {
    return ALL_RECORDS_CQL;
  }

  if (query && option === SEARCH_OPTION.advanced) {
    return transformMaskedQueryToCql(query);
  }

  if (query && option === SEARCH_OPTION.query) {
    return query;
  }

  return query && `${searchOptionMap[option]} "${sanitizedQuery}"`;
};
